import React from 'react'
import Immutable from "immutable"
import PropTypes from "prop-types"
import { Form } from "reactstrap"
import { reduxForm } from "redux-form"
import SelectionableTable from '../../../common/forms/table/SelectionableTable'
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants'
import FormFooter from '../../../common/forms/FormFooter'
import { generateLegalTicketColumns } from '../../../../config/columns'

const LegalTicketTableForm = ({
  loading,
  legalTickets,
  handleSubmit,
  printAction
}) => (
  <Form onSubmit={handleSubmit}>
    <SelectionableTable
      columns={generateLegalTicketColumns(printAction)}
      data={legalTickets.toJS()}
      name="items"
      loading={loading}
      manual={false}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      returnOnlySelectedItems
      filterable
      emptyText="No hay resultados para mostrar."
      keyField="idSourceSystem"
      required
      form="legalTicketTableForm"
    />
    <FormFooter
      saveButtonText="Exportar"
      saveButtonIcon="fa fa-file-excel-o"
    />
  </Form>
)

LegalTicketTableForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  legalTickets: PropTypes.instanceOf(Immutable.List).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  printAction: PropTypes.func.isRequired,
}

export default reduxForm({
  form: "legalTicketTableForm"
})(LegalTicketTableForm)